import { Routes } from '@angular/router';
// import { HomeComponent } from './partial/home/home.component';
import { OAuth2Guard } from './services/auth.guard';

export const APP_ROUTES: Routes = [
  { path: '', redirectTo: 'proposal', pathMatch: 'full' },
  { path: 'el-web', redirectTo: 'proposal', pathMatch: 'full' },
  { path: 'home', redirectTo: 'proposal', pathMatch: 'full' },
  {
    path: 'proposal',
    canActivate: [OAuth2Guard],
    loadChildren: () => import('./partial/quotation/quotation-routing.module').then((mod) => mod.QuotationRoutingModule),
  },
  {
    path: 'registration',
    loadChildren: () => import('./partial/registration/registration-routing.module').then((mod) => mod.RegistrationRoutingModule),
  },
  {
    path: 'unauthorize',
    loadChildren: () => import('./partial/role-unauthorize/role-unauthorize-routing.module').then((mod) => mod.RoleUnauthorizeRoutingModule),
  },
  // {
  //   path: 'proposal-information',
  //   loadChildren: () =>
  //     import('./partial/proposal-information/proposal-information.module').then(
  //       (mod) => mod.ProposalInformationModule
  //     ),
  // },
  // {
  //   path: 'uwtask-list',
  //   loadChildren: () =>
  //     import('./partial/uwtask-list/uwtask-list.module').then(
  //       (mod) => mod.UWTastListModule
  //     ),
  // },
  // {
  //   path: 'benefit-table',
  //   loadChildren: () =>
  //     import('./partial/benefit-table/benefit-table.module').then((mod) => mod.BenefitTableModule),
  // },
  // {
  //   path: 'upload-member',
  //   loadChildren: () =>
  //     import('./partial/upload-member/upload-member.module').then((mod) => mod.UploadMemberModule),
  // },
];
